import { ChevronRight, Download, MessageSquare, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SEOHead } from "../components/SEOHead";
import { AllergyForm } from "../components/allergy-card/AllergyForm";
import { AllergyPreview } from "../components/allergy-card/AllergyPreview";
import { AllergyCardGuide } from "../components/allergy-card/AllergyCardGuide";
import { ALLERGY_UI } from "../features/allergy-card/copy";
import { ALLERGY_CARD_SEO } from "../features/allergy-card/seoContent";
import { useAllergyCard } from "../features/allergy-card/useAllergyCard";
import { localizePath, normalizeLocale } from "../lib/localeRoutes";

export default function AllergyCard() {
  const { i18n } = useTranslation();
  const locale = normalizeLocale(i18n.language);
  const copy = ALLERGY_UI[locale];
  const seo = ALLERGY_CARD_SEO[locale];
  const state = useAllergyCard(locale);

  return (
    <>
      <SEOHead title={seo.title} description={seo.description} />
      <section className="px-6 pb-16 pt-8 sm:pt-12">
        <div className="mx-auto max-w-5xl">
          <nav aria-label={copy.resources} className="mb-7 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
            <Link to={localizePath("/resources", locale)} className="inline-flex min-h-11 items-center hover:text-primary">{copy.resources}</Link><ChevronRight className="h-3 w-3" aria-hidden="true" />
            <Link to={localizePath("/free-tools", locale)} className="inline-flex min-h-11 items-center hover:text-primary">{copy.tools}</Link><ChevronRight className="h-3 w-3" aria-hidden="true" />
            <span className="text-foreground" aria-current="page">{copy.card}</span>
          </nav>
          <header className="mb-7 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
            <div><p className="text-xs font-semibold uppercase tracking-widest text-primary">{copy.eyebrow}</p><h1 className="mt-3 max-w-2xl text-4xl font-bold leading-[1.15] tracking-tight sm:text-5xl">{copy.title}</h1><p className="mt-3 max-w-xl text-base leading-7 text-muted-foreground">{copy.description}</p></div>
            <p className="flex items-center gap-2 text-xs text-muted-foreground"><ShieldCheck className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />{copy.free}</p>
          </header>
          <div className="ph-no-capture ph-mask grid overflow-hidden rounded-2xl border border-border bg-card lg:grid-cols-[minmax(0,1fr)_minmax(0,1.04fr)]" data-allergy-builder>
            <AllergyForm state={state} copy={copy} />
            <AllergyPreview state={state} copy={copy} />
          </div>
          <section className="mt-7 grid gap-5 border-b border-border pb-7 sm:grid-cols-2 sm:gap-8" aria-label={copy.usage}>
            <div><h2 className="font-semibold">{copy.usage}</h2><div className="mt-3 flex flex-wrap gap-4 text-xs text-muted-foreground"><span className="flex items-center gap-1.5"><Download className="h-4 w-4 text-primary" aria-hidden="true" />{copy.save}</span><span className="flex items-center gap-1.5"><MessageSquare className="h-4 w-4 text-primary" aria-hidden="true" />{copy.show}</span><span>{copy.confirm}</span></div></div>
            <p className="text-sm leading-6 text-muted-foreground">{copy.disclaimer}</p>
          </section>
          <AllergyCardGuide locale={locale} />
        </div>
      </section>
    </>
  );
}
